export default __webpack_public_path__ + "static/media/aliza.ed100122.png";